<template >
  <div class="container-fluid p-0">
    <div class="container-fluid">
      <div class="d-flex justify-content-between">
        <h3 class="mr-2">{{content.name}}</h3>
        <!-- <div class="d-flex justify-content-start align-items-center">
  
          <span class="badge badge-warning" v-if="content.type!=null && content.type!=undefined" style="color:black">
            {{content.type}}
          </span>  
        </div> -->
        <h3 class="text-danger font-weight-bold">({{content.totalScore}})</h3>
        <div class="col"></div>
        <div class="p-1 bd-highlight mr-3"><i class="fas fa-edit text icon-bg"  @click="_editContent()" ></i></div>
        <div class="p-1 bd-highlight mr-3"><i class="fas fa-eye mr-3 text icon-bg"  @click="_viewAsUser()" ></i></div>
        
        <button v-if="content&&content.published==null || content.published==false" class="btn btn-sm btn-mygray mr-3" @click="_addCategory">Бүлэг нэмэx</button>
        <!-- <button v-if="content&&content.published!=true" class="btn btn-info btn-sm mr-3 " @click="$router.push({ name: 'IQuestionsScore', params: {schoolId: schoolId,  lessonId:lessonId, topicId:topicId, detailId: detailId} })">Асуултууд мэдээлэл засах</button> -->
        <button  @click="_setPublishedContent(false)"
                    v-if="content&&content.published==true"
                    class="btn btn-success btn-sm">Нээлттэй</button>
        <button @click="_setPublishedContent(true)"
                    v-else
                    class="btn btn-danger btn-sm"
                  >Xаагдсан</button>
      </div>

      <div class="d-flex justify-content-center" style="margin-top:12pt;">
        <ul>
            <li class="bottom-bordered mr-4">
                Асуултууд
            </li>
            <li style= "cursor:pointer" @click="$router.push({name:'ILessonGroupExam', params: {schoolId:schoolId, lessonId: lessonId, topicId:topicId, contentId:detailId}})">
                Xариултууд
            </li>
          </ul>
      </div>
    </div>
 
  
    <section style="margin-top:40pt">
      <div class="container">
      <div class="row justify-content-center">
        <div class="col-10">
        <div v-if="categories!=null && categories.length>0">
          <div v-for="(cat, index) in categories" v-bind:key="cat.id">
              <div class="card mycard mb-4">
                <div class="card-header bg-info">
                  <div class="d-flex justify-content-between align-items-center">
                    <h3 class="m-0 font-weight-bold" style="font-size:14pt">{{index+1}}. {{cat.name}} ({{cat.index}} -р хэсэг)</h3>
                    <div class="d-flex justify-content-end">
                      <i class="fas fa-trash mr-4 icon-sm" @click="deleteCategory(cat)"></i>
                      <i
                        class="fas fa-edit icon-sm"
                        @click="editCategory(cat)"
                        
                        data-toggle="Засаx"
                        data-placement="bottom"
                        title="Засаx"
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                <div class="row my-3" v-if="content!=undefined && content.published!=true">
                  <div class="col-md-auto">
                    <button class="btn btn-mygray btn-sm" @click="addQuestion(cat.id, true)">Aсуулт нэмэх</button>
                  </div>
                  <div class="col-md-auto" v-if="cat.index!=null && cat.index!=undefined">
                    <!-- <button class="btn btn-mygray btn-sm" @click='$router.push({ name: "IQuestionAddBulk", params: {schoolId:schoolId, lessonId: lessonId, categoryId:cat.id, detailPath:"schools/"+schoolId+ "/lessons/" + lessonId + "/topics/"+topicId+"/details/"+detailId} })'>Асуулт бөөнөөр нэмэx</button> -->
                  </div>
                  <!-- <div class="col-md-auto">
                    <button class="btn btn-danger btn-sm" @click="addQuestion(cat.id, false)">Дэд асуулттай асуулт нэмэх</button>
                  </div> -->
                </div>
                </div>
              </div>
  
              <div v-if="cat.questions!=null && cat.questions.length>0">
                <div class="mb-4" v-for="(que, indx) in cat.questions" v-bind:key="que.id">
                    <div class="card mycard hoveredcard mb-4" v-for="(subquestion, index) in que.subquestions" v-bind:key="subquestion.id">
                     
                      <div class="card-body py-3">
                          <div class="mr-2 d-flex justify-content-end">
                            <i class="fas fa-trash mr-2" style="cursor:pointer" @click="deleteQuestion(que, cat, index)"></i>
                            <span class="text-muted mx-2">|</span> 
                            <i class="fas fa-edit mr-2" style="cursor:pointer" @click="editQuestion(que, cat)"></i>
                            <span class="text-muted mx-2">|</span> 
                            <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'schools/'+schoolId+'/lessons/'+lessonId+'/topics/'+ topicId+'/details/'+detailId+'/tests/'+cat.id+'/questions/'+que.id}}">Зураг оруулаx</router-link>
                          </div>
                          <hr/>
                          <h5 class="asuulga-title" v-if="isLatex(subquestion.title)==true">
                              {{indx+1}}. <vue-mathjax :formula="getLatexText(subquestion.title)"></vue-mathjax>
                              <p class="ml-3 badge badge-danger">{{subquestion.score}} оноо</p>
                              </h5>
                              <div v-else class="d-flex justify-content-between align-items-center">
                                <span class="asuult-title">{{indx+1}}. {{subquestion.title}}</span> 
                                <p class="ml-3 badge badge-danger">{{subquestion.score}} оноо</p>
                              </div>
                              <hr/>
                              <p v-if="subquestion.description!=null && subquestion.description!=''"><span style="font-weight:bold">Тайлбар: </span>{{subquestion.description}}</p>
                              <p v-else style="color:red">Тайлбар ороогүй</p>    
                             <div class="row  text-center text-lg-left" v-if="que.images!=null && que.images.length>0">
                                <div class="col-lg-3 col-md-4 col-6" v-for="(file, index) in que.images" v-bind:key="file.fileUrl">
                                    <a href="#" class="d-block mb-4 h-100">
                                    <img class="img-fluid img-thumbnail" :src="file.fileUrl" @click="deleteFile(file, index)"/>
                                    </a>
                                </div>
                            </div>
                            <div class="my-2" v-if='que.tags!=null && que.tags.length>0'>
                              <label>Түлхүүр үгс: </label>
                              <span class="badge badge-pill badge-success mr-2" v-for="(tag, ti) in que.tags">
                                {{tag}}
                              </span>
                            </div>
                        <hr/>
                        <p v-if="subquestion.solution!=null && subquestion.solution!=''">
                          <span class="h6" style="font-weight:bold; color:red">Xариу тайлбар:  </span>
                          <span v-if="isLatex(subquestion.solution)==true">
                            <vue-mathjax :formula="getLatexText(subquestion.solution)"></vue-mathjax>
                          </span>
                          <span v-else>{{subquestion.solution}}</span>
                        </p>
                        
                        <p v-if="subquestion.videoUrl!=null && subquestion.videoUrl!=''">
                          <span class="h6">Асуултын шийдэл видео:  </span>
                          <a v-bind:href="subquestion.videoUrl" target="blank">Видео үзэх</a>
                        </p>
                        <div v-if="subquestion.answertype==true">
                          <div class="panel panel-primary" id="result_panel" v-if="subquestion.useranswers!=null && subquestion.useranswers.length>0">
                            <div class="panel-heading">
                              <h6 class="panel-title">Хариултууд</h6>
                            </div>
                            <div class="panel-body">
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(answer, index) in subquestion.useranswers" v-if="answer!=null && answer.answer!=null && answer.answer!='Хариулт байхгүй'">
                                      <strong>{{index+1}}.</strong> 
                                      <span v-if="isLatex(answer.answer)==true">
                                        <vue-mathjax :formula="getLatexText(answer.answer)"></vue-mathjax>
                                      </span>
                                      <span v-else>{{answer.answer}}</span>

                                    </li>
                                </ul>
                            </div>
                          </div>
                          
                        </div>

                        <div v-else>
                            <div class="col-lg-6 mb-4" v-if="subquestion.answers!=null && subquestion.answers.length>0">
                             <div class="panel-heading">
                              <h6 class="panel-title">Хариултууд</h6>
                            </div>
                              
                                <li
                                  v-for="(answer, index) in subquestion.answers"
                                  v-bind:key="answer.id"
                                  class="list-group-item"
                                >
                                  <div class="row">
                                    <div class="col col-10">
                                      <span class="font-weight-bold">{{index+1}}. &nbsp;</span> 
                                      <span v-if="isLatex(answer.name)==true">
                                        <vue-mathjax :formula="getLatexText(answer.name)"></vue-mathjax>
                                      </span>
                                      <span v-else>{{answer.name}}</span>
          
                                    </div>
                                    <div class="col col-2">
                                      <span v-if="answer.correct" class="badge badge-success">зөв</span>
                                    </div>
                                  </div>
                                </li>
                              
                            </div>
                    

                          <div v-else class="alert alert-success">Одоогоор энэ асуултанд хариулт оруулаагүй байна.</div>
                        </div>
                      </div>
                      <!-- <div class="card-footer">
                        <div class="d-flex justify-content-center">
                      
                        <button class="btn btn-sm btn-success mb-3" @click='$router.push({ name: "IQuestionDetail", params: {schoolId:schoolId, lessonId: lessonId, topicId:topicId, contentId: detailId, categoryId:cat.id, questionId: que.id} })'>Дэлгэрэнгүй харах</button>
                    </div>
                      </div> -->
                    </div>

                </div>
              </div>
          </div>
        </div> 
      
        </div>
      </div>

     <div
      class="modal fade"
      id="qaModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="qaModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="qaModalLabel">Бүлэг нэмэх</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                  <input v-if="selectedCategory!=null" 
                  v-model.trim="selectedCategory.name"
                  class="form-control"
                  id="exampleInputEmail"
                  aria-describedby="emailHelp"
                  placeholder="Бүлгийн нэр"
                />  
              </div>
              <div class="form-group">
                  <input v-if="selectedCategory!=null" 
                  v-model.number="selectedCategory.index"
                  class="form-control"
                  placeholder="Бүлгийн дугаар"
                />  
              </div>

              <div class="form-group">
                  <textarea v-if="selectedCategory!=null" 
                  v-model.trim="selectedCategory.description"
                  class="form-control"
                  placeholder="Бүлгийн санамж тайлбар"
                />  
              </div>

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button
              @click="changeCategoryName"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >Save</button> 
          </div>
        </div>
      </div>
    </div>

      <div class="modal fade" id="contentModal" tabindex="-1" role="dialog" aria-labelledby="contentModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Агуулга нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" v-if="content">
              <form class="user">
                <div class="form-group">
                  <label>Агуулгын нэр: </label>
                  <input v-model.trim="content.name" class="form-control" placeholder="Агуулгын нэр">
                </div>
                <div class="form-group">
                   <label>Агуулгын товч нэр: </label>
                  <input v-model.trim="content.shortname" class="form-control" placeholder="Агуулгын товч нэр /VA, VariantB/">
                </div>
                <div class="form-group">
                  <label>Агуулгын дэлгэрэнгүй тайлбар: </label>
                  <textarea rows="10" v-model.trim="content.description" class="form-control"  placeholder="Агуулгын дэлгэрэнгүй"/>
                </div>
                <div class="form-group">
                  <label>Youtube видеоны линк: </label>
                  <input v-model.trim="content.videoUrl" class="form-control" placeholder="Видеоны линк">
                </div>
                <div class="form-group">
                  <label>IFrame линк/Жишээлбэл: GoogleDoc, Slide, Microsoft office, Slideshare .../ </label>
                  <textarea rows="2" v-model.trim="content.iframeurl" class="form-control"  placeholder=""/>
                </div>
                <div class="form-group">
                  <label for="exampleFormControlSelect1">Агуулгын төрөл: </label>
                  <select class="form-control" v-model="selectedType" >
                    <option v-for="(type) in types" v-bind:key="type.id" v-bind:value="type.id">{{type.title}}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Эхлэх: </label>
                  <input v-model="content.startDayStr" class="form-control form_datetime" type="date" placeholder="Агуулга нээгдэх хугацаа" >
                </div>
                <div class="form-group">
                  <label>Дуусах: </label>
                  <input v-model="content.endDayStr" class="form-control form_datetime" type="date" placeholder="Агуулга дуусах хугацаа">
                </div>
                 <div class="form-group">
                  <label>Агуулгын үргэлжлэх хугацаа/мин/: </label>
                  <input v-model.number="content.duration" class="form-control" type="number" placeholder="Агуулгын үргэлжлэх хугацаа">
                </div>
                <div class="row" v-if="selectedType && selectedType=='assignment'">
                  <div class="col">
                    <div class="form-check">
                      <input type="checkbox" v-model="content.graded" class="form-check-input" id="exampleCheck1">
                      <label class="form-check-label" for="exampleCheck1">Оноотой эсэх</label>
                    </div>
                  </div>
                  <div class="col" v-if="content && content.graded && content.graded==true">
                    <div class="form-group">
                      <label>Дүгнэх дээд оноо: </label>
                      <input v-model.number="content.totalScore" class="form-control" type="number" placeholder="Дээд оноо">
                    </div>
                  </div>
                </div>
     

                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
              <button @click="saveContent()" type="button" class="btn btn-primary btn-user btn-block">Хадгалах</button>
            </div>
          </div>
        </div>
      </div>

      </div>
    </section>
    
    <!-- <vue-mathjax :formula="getLatexText()"></vue-mathjax> -->

  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import BarChart from "../../BarChart.js";
import { stat } from "fs";
import {VueMathjax} from 'vue-mathjax'
import latexmixin from '../../global/latex.js';
import IContentDetail from './IContentDetail';
import firebase from 'firebase';
import mixin from '../../global/mixin.js';
var colors=[
  "#00E396",
  "#FEB019",
  "#FF4560",
  "#775DD0",
  "#546E7A",
  "#26a69a",
  "#D10CE8"
];
export default {
  name: "CreatingQuestions",
  components: {
    'bar-chart': BarChart,
    'vue-mathjax': VueMathjax,
    'content-detail': IContentDetail
  },
  mixins: [latexmixin, mixin],
  data() {
    return {
      selectedCategory: null,
      categories: [],
      questions: [],
      
      item:null,
      types:[],
      selectedType:null,
      content:{
      },
      itemDetails:[],
      topic:null,

      formula: '\(x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}.\)',
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [
            {
              ticks: {
                userCallback: function(label, index, labels) {
                  if (typeof label === "string" && label.length > 10) {
                    return label.substring(0, 20) + " ...";
                  }
                  return label;
                }
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      statData: {
        chartOptions: {
          chart: {
            id: "basic-bar"
          },
          colors: colors,
          labels: {
            show: true,
            hideOverlappingLabels: false
          },
          plotOptions: {
            bar: {
              distributed: true,
              horizontal: true,
              endingShape: "rounded"
            }
          }
          // plotOptions: {
          //     bar: {
          //     horizontal: false,
          //     columnWidth: '55%',
          //     endingShape: 'rounded'
          //     },
          // },
        },
        series: [
          {
            name: "series-1",
            data: [
              {
                x: "Apple",
                y: 54
              },
              {
                x: "Orange",
                y: 66
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    _viewAsUser(){
       this.$router.push({ name: 'ExamPage', params: {schoolId: this.schoolId, lessonId: this.lessonId, topicId: this.topicId, contentId: this.content.id} });
    },
      saveContent() {
        if(this.content!=null && this.content.name!=null && this.content.name!='' && this.selectedType!=null){
          if(this.content.videoUrl!=null && this.content.videoUrl!='' ){
            if (this.content.videoUrl.toLowerCase().indexOf("youtube") == -1) {
              alert("Та заавал youtube бичлэг оруулна уу");
              return;
            }
          }
          this.content.typeRef=fb.db.collection("ContentTypes").doc(this.selectedType);
          this.content.type=this.selectedType;
        
          if(this.lessonId!=null && this.topicId!=null && this.content){
   
              if(this.content.startDayStr!=null && this.content.startDayStr!=''){
                this.content.startDay=new Date(this.content.startDayStr);
                console.log(this.content)
              }

              if(this.content.endDayStr!=null && this.content.endDayStr!=''){
                this.content.endDay=new Date(this.content.endDayStr);
              }
                  
              if(this.selectedType!=null && this.selectedType=="exam"){
                this.content.roundCount=1;
              }
              else if(this.selectedType!=null && this.selectedType=="test"){
                this.content.roundCount=10;
              }

              if(this.content.id!=undefined && this.content.id!=null && this.content.id!='' && this.content.id!='new'){
                this.content.modifiedAt=new Date();
                fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection("details").doc(this.content.id).update(this.content)
              }
              else{
                this.content.createdAt=new Date();
                this.content.code=new Date().getTime().toString();
                fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection("details").doc().set(this.content)
                fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topicId).update({
                  'numberOfContent':fb.firestore.FieldValue.increment(1)
                });

                fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).update({
                  'numberOfContent':fb.firestore.FieldValue.increment(1)
                });
                
                if(this.content.videoUrl!=null && this.content.videoUrl!=''){
                  fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).update({
                    'numberOfVideos':fb.firestore.FieldValue.increment(1)
                  });
                }

              }
              

              this.selectedType=null;
              this.selectedTopic=null;
              this.content={
                'name':null,
                'description':null,
                'videoUrl':null,
                'published':false,
                'startDay':null,
                'endDay':null,
                'code':null,
                'duration':null,
                'shortname':null,
                iframeurl:null
              }
    
          }
          $('#contentModal').modal('hide');
        }
        else{
          alert("Та талбаруудыг гүйцэд бөглөнө үү");
        }
      },
      _editContent(){

        console.log(this.item);
          this.content= Object.assign({}, this.item);
          this.selectedType=this.item.type;
          $('#contentModal').modal('toggle');
      },
    _getQA() {

      fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).get().then(doc=> {
            doc.ref.collection("topics").doc(this.topicId).get().then(tdoc=>{
              if(tdoc.exists){
                let topic=tdoc.data();
                topic.id=tdoc.id;
                this.topic=topic;
                console.log(this.topic);
              }
            });
      });


      fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).get().then(doc=> {
            let lesson=doc.data();
            lesson.id=doc.id;
            this.lesson=lesson;
            doc.ref.collection("topics").doc(this.topicId).get().then(tdoc=>{
              if(tdoc.exists){
                let topic=tdoc.data();
                topic.id=tdoc.id;
                this.topic=topic;

                tdoc.ref.collection("details").doc(this.detailId).onSnapshot(cdoc=>{
                  if(cdoc.exists){
                    let item=cdoc.data();
                    item.id=cdoc.id;
                    item.uploading=false;
                    item.uploadPercent=0;
                    if(!item.startDayStr)
                      item.startDayStr=null;
                    if(!item.endDayStr)
                      item.endDayStr=null;
                    if(!item.startDay)
                      item.startDay=null;
                    if(!item.endDay)
                      item.endDay=null;
                    if(item && item.iframeurl){
                      if(item.iframeurl.includes("docs.google.com/document")){
                        item.iframeurl=item.iframeurl.replace("<iframe ", "<iframe style='height:1024px'");
                      }
                    }
                      
                    this.item=item;
                    cdoc.ref.collection("subdetails").orderBy("createdAt", "desc").onSnapshot(docs=>{
                      if(docs!=null && !docs.empty){
                        this.itemDetails=docs.docs;
                      }
                    });
                  }
                });
              }
            });
          
        });

          fb.db.collection("ContentTypes").get().then(querySnapshot=> {
              this.types=[]
              querySnapshot.forEach(doc=> {
                let object=doc.data()
                object.id = doc.id
                object.content=[]
                this.types.push(object);
              });
            
          });

      fb.db
        .collection('schools/'+this.schoolId+"/lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/questions").orderBy("createdAt","asc")
        .onSnapshot(querySnapshot => {
          this.questions = [];
          querySnapshot.forEach(doc => {
             let question=doc.data();
              question.id=doc.id;
              question.subquestions=[];

              doc.ref.collection("subquestions").get().then(subDocs=>{
                subDocs.forEach((subquestion, index)=> {
                    let object=subquestion.data();
                    object.id = subquestion.id;
                    object.answers=[];
   
                    if(object.answertype==true){
                      object.useranswers=[]
                      this._getQuestionAnswers(object, subquestion.ref);
                    }
                    else{
                      object.answers = [];
                      this._getAnswers(object, subquestion.ref);
                    }

                    question.subquestions.push(object);

                });
              });

              this.questions.push(question);
          });
        });
    },
    _getAnswers(question, ref) {
      if (question.answers == null || question.answers == undefined)
        question.answers = [];
      ref
        .collection("answers")
        .orderBy("index", "asc")
        .onSnapshot(querySnapshot => {
          question.answers = [];
          let labels = [];
          let dataset = [
            {
              label: "A",
              backgroundColor: "#f87979",
              data: [],
              backgroundColor: []
            }
          ];
          let data = [];
          let index = 0;
          let answered = false;
          querySnapshot.forEach(doc => {
            let answer = doc.data();
            answer.id = doc.id;
            if (answer.votedCount != null && answer.votedCount > 0)
              answered = true;
            labels.push(answer.name);
            dataset[0].data.push(answer.votedCount);
            dataset[0].backgroundColor.push(
              index <= colors.length ? colors[index] : this.getRandomColor()
            );
            data.push({
              x: answer.name,
              y: answer.votedCount,
              color: this.getRandomColor()
            });

            question.answers.push(answer);
            index++;
          });
          if (answered == true) {
            question.statData = this.statData;
            question.datacollection = {
              labels: labels,
              datasets: dataset
            };
            // this.statData.chartOptions.xaxis.categories=labels
            question.statData.series = [
              {
                name: "санал",
                data: data
              }
            ];
          } else {
            question.datacollection = null;
            question.statData = null;
          }
        });
    },
    _getQuestionAnswers(question, ref){
      ref.collection("votedusers").get().then(querySnapshot=>{
        querySnapshot.forEach(doc => {
          let answer = doc.data();
          answer.id = doc.id;
          question.useranswers.push(answer);
        });
      });
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    editCategory(cat) {
      
      this.selectedCategory = Object.assign({}, cat);

      $("#qaModal").modal();
    },
    changeCategoryName(selectedCategory){

      fb.db.collection('schools/'+this.schoolId+"/lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests").doc(this.selectedCategory.id).update(this.selectedCategory);
            
    },
    editQuestion(question, category) {

      if(category!=null){
        if(question.simple==true)
          this.$router.push({ name: "ISimpleQuestionAdd", params: { questionId: question.id, categoryId:category.id, detailPath: "schools/"+this.schoolId+ "/lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });
        else
          this.$router.push({ name: "IQuestionAdd", params: { questionId: question.id, categoryId:category.id, detailPath: "schools/"+this.schoolId+ "/lessons/"+this.topicId+"/details/"+this.detailId} });
      }
      else{
        if(question.simple==true)
          this.$router.push({ name: "ISimpleQuestionAdd", params: { questionId: question.id, categoryId:'new', detailPath: "schools/"+this.schoolId+ "/lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });
        else
          this.$router.push({ name: "IQuestionAdd", params: { questionId: question.id, categoryId:'new', detailPath: "schools/"+this.schoolId+ "/lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });
      }
    },
    
    async deleteQuestion(question, category, index){
       var result = confirm("Та "+question.title+" асуултыг устгаxыг xүсэж байна уу? : "+ question.id + " " + category.name);
        if (result) {
          var qRef= fb.db.collection('schools/'+this.schoolId+"/lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests").doc(category.id).collection("questions").doc(question.id);
          var batch = fb.db.batch();
          var subqs=await qRef.collection('subquestions').get();
          if(subqs!=null && subqs.docs.length>0){
            for(const sq of subqs.docs){
              if(sq.exists){
                var answers=await sq.ref.collection('answers').get();
                if(answers!=null && answers.docs.length>0){
                  for(const adoc of answers.docs){
                    if(adoc.exists){
                      batch.delete(adoc.ref);
                    }
                  }
                }
                batch.delete(sq.ref);
              }
            }
          }
          batch.delete(qRef);
          batch.commit();
          category.questions.splice(index, 1);
        }
    },
    deleteCategory(cat){
      var result = confirm("Та устгаxыг xүсэж байна уу? : "+ cat.id + " " + cat.name);
      if (result) {
        fb.db.collection('schools/'+this.schoolId+"/lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests").doc(cat.id).delete()
        this.categories.splice(cat);
      }
    },
    addQuestion(cat, simple) {
      if(simple==true)
        this.$router.push({ name: "ISimpleQuestionAdd", params: { questionId: "new", categoryId:cat, detailPath:"schools/"+this.schoolId+ "/lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });
      else
         this.$router.push({ name: "IQuestionAdd", params: { questionId: "new", categoryId:cat, detailPath: "schools/"+this.schoolId+ "/lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });

    },
    addBulkQuestion() {
      this.$router.push({ name: "QuestionAddBulk", params: { questionId: "new",} });
    },
    _setLabel(questionId, status, field, category) {
      var tmp = {};
      tmp[field] = status;
      if(category==null || (category!=null && category.id==null))
        fb.db
          .doc('schools/'+this.schoolId+"/lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId)
          .collection("questions")
          .doc(questionId)
          .update(tmp);
      else{
        fb.db
          .doc('schools/'+this.schoolId+"/lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId+'/tests/'+category.id)
          .collection("questions")
          .doc(questionId)
          .update(tmp);
      }
    },
    _setPublishedContent(status) {
      fb.db
        .doc('schools/'+this.schoolId+"/lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId)
        .update({'published':status});
      this.content.published=status;
     
    },
    _getQuestionsOfCategory(cat, catRef){
      catRef
        .collection("questions").orderBy("createdAt","asc").get().then(querySnapshot =>{
          cat.questions=[];
          querySnapshot.forEach(doc => {

              let question=doc.data();
              question.id=doc.id;
              question.subquestions=[];
              question.path=doc.ref.path;

              doc.ref.collection("subquestions").get().then(subDocs=>{
                question.subquestions=[];
                subDocs.forEach((subquestion, index)=> {
                    let object=subquestion.data();
                    object.id = subquestion.id;
                    object.answers=[];
   
                    if(object.answertype==true){
                      object.useranswers=[]
                      this._getQuestionAnswers(object, subquestion.ref);
                    }
                    else{
                      object.answers = [];
                      this._getAnswers(object, subquestion.ref);
                    }

                    question.subquestions.push(object);

                });

              cat.questions.push(question);
            })
          });
        });
    },
    _findCategories(){


      fb.db
        .collection('schools/'+this.schoolId+"/lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests").orderBy("createdAt","asc")
        .onSnapshot(querySnapshot => {
          this.categories = [];
          querySnapshot.forEach(doc => {
            let cat = doc.data();
            cat.id = doc.id;
            cat.questions=[]
            this._getQuestionsOfCategory(cat, doc.ref)
            this.categories.push(cat);
          });
        });

      this.categories.push({name:'--no group--', id:'null'});

    },
    _addCategory(){
      if(this.categories==null)
        this.categories=[];
      // if(this.categories.length==0){
        var newCategory={
          name:'Бүлэг-'+ this.categories.length,
          createdAt: new Date(),
          index: this.categories.length+1
        }
        fb.db.collection('schools/'+this.schoolId+"/lessons")
              .doc(this.lessonId)
              .collection("topics").doc(this.topicId).collection("details").doc(this.detailId).collection('tests').doc().set(newCategory)
      // }
    },
    getContent(){
      fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId).onSnapshot(detailDoc=>{
        if(detailDoc.exists){
          let item=detailDoc.data();
          item.id=detailDoc.id;

          item.uploading=false;
          item.uploadPercent=0;
          if(!item.startDayStr)
            item.startDayStr=null;
          if(!item.endDayStr)
            item.endDayStr=null;
          if(!item.startDay)
            item.startDay=null;
          if(!item.endDay)
            item.endDay=null;
          if(item && item.iframeurl){
            if(item.iframeurl.includes("docs.google.com/document")){
              item.iframeurl=item.iframeurl.replace("<iframe ", "<iframe style='height:1024px'");
            }
          }
            
          this.content=item;
          this.item = item;

          // detailDoc.ref.collection("subdetails").orderBy("createdAt", "desc").onSnapshot(docs=>{
          //   if(docs!=null && !docs.empty){
          //     this.itemDetails=docs.docs;
          //   }
          // });
        }

      });
    },
    getLtx(text){
      this.$nextTick(() => {

      })
    },
      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
    demoAnswer(){
      if(this.detailId){

        var demo = firebase.functions().httpsCallable('demotest');
        demo(
          {
            testPath: fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId).path,
            personCount:50
          }
          ).then(function(result) {
   
        });
      }
    }
    
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },

  props: {
    schoolId:{
      required:true
    },
    lessonId: {
      required: true
    },
    topicId: {
      required: true
    },
    detailId: {
      required: true
    }
  },
  created() {

    //this.toggleSideBar();

    if(this.lessonId!=null && this.lessonId!='' && this.topicId!=null && this.topicId!='' && this.detailId!=null && this.detailId!='' ){

      fb.db.collection("ContentTypes").get().then(querySnapshot=> {
          this.types=[]
          querySnapshot.forEach(doc=> {
            let object=doc.data()
            object.id = doc.id
            object.content=[]
            this.types.push(object);
          });
      });
      this._findCategories();
      this.getContent();
    }
    
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    }
  }
};
</script>

<style>
  .panel-body >.list-group{
      max-height: 350px;
      margin-bottom: 10px;
      overflow-y:auto;
      -webkit-overflow-scrolling: touch;
  }
  ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

li {
  display: inline;
}
.bottom-bordered{
    border-bottom:4px solid rgb(17,205,239);
}
li h5{
  display: inline;
  margin-right: 1rem;
  border-bottom: solid 0.125rem transparent;
  box-sizing: border-box;
  height: 100%;
  padding: 0.125rem 1.5rem 0 1.5rem;
  position: relative;
  text-decoration: none;
  color:#5f6368;
  
  letter-spacing: .01785714em;
  font-family: 'Google Sans',Roboto,Arial,sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  color: #3c4043;
  text-transform: none;
}
.hoveredcard:hover{
  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.302), 0 2px 6px 2px rgba(60,64,67,0.149);   
  /* transform: scale(1.1); */
  cursor:pointer;
  border-left: 0.25rem solid #ED3D63 !important;
}

.asuult-description{
  color: #202124;
  font-family: Roboto,Arial,sans-serif;
  font-size: 14px;
  font-weight: 400;
}
.asuult-title{
  color: #202124;
  font-family: Roboto,Arial,sans-serif;
  font-size: 32px;
  font-weight: 400;
}
.fixed-toolbar{
  background-color: #fff;
  border-bottom: 1px solid #dadce0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
  height: 106px;
}
/* #accordionSidebar{
  display: none;
} */
</style>
 
